import React from 'react';
import SidePanelOverlay from '../../../../side-panel-overlay/SidePanelOverlay';
import { Link as LinkStyle, getHelpCenterLinks } from 'venn-ui-kit';

type HeaderSubtitleProps = {
  text: string;
};
const HeaderSubtitle = ({ text }: HeaderSubtitleProps) => (
  <>
    {text}{' '}
    <LinkStyle>
      <a
        className="text-venn-dark-blue"
        href={getHelpCenterLinks().PROXY_FAQ_HREF}
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn more
      </a>
    </LinkStyle>
  </>
);

type HeaderProps = {
  title: string;
  subtitle: string | undefined;
};
export const ProxyPickerHeader = ({ title, subtitle }: HeaderProps) => (
  <SidePanelOverlay.Header.Container paddingTop="default">
    <SidePanelOverlay.Header.Main title={title} subtitle={subtitle ? <HeaderSubtitle text={subtitle} /> : null} />
  </SidePanelOverlay.Header.Container>
);
